module.exports = __webpack_public_path__ + "img/CFI.00cf3592.svg";